// The only place in the voice feature that touches localStorage, following mapSettings and
// chatSettings. It also owns the key format, so the repo's double-underscore convention is
// written down once. Every value here is tuning scaffolding — see the spec's required follow-up.
class VoiceSettings {
  private key = (name: string) => `__MMC_VOICE_INPUT_${name}__`;

  getOverride = (name: string): null | string => localStorage.getItem(this.key(name));

  setOverride = (name: string, value: string): void => {
    localStorage.setItem(this.key(name), value);
  };

  clearOverride = (name: string): void => {
    localStorage.removeItem(this.key(name));
  };
}

export default new VoiceSettings();
